'use strict';
module.exports = {
	truncate: function (str, length) {
		return str.substring(0, length);
	},
	sanitize: function (s) {
		const slug = s.substr(0, 100).toLowerCase().replace(/[^a-z0-9]+/g, '_');
		return slug === '_' ? 'map' : slug;
	}
};
